"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WhoIsRegisteredKeeperWidget = void 0;
var React = require("react");
var DriverKeeperPopupWidget_1 = require("./DriverKeeperPopupWidget");
var commonFunctions_1 = require("../../../commonFunctions");
var FalconQuestionWidgetBase_1 = require("../../FalconQuestionWidgetBase");
var services_1 = require("@falcon/services");
var core_1 = require("@athena-portal/core");
var components_1 = require("@athena-portal/components");
var WhoIsRegisteredKeeperWidget = exports.WhoIsRegisteredKeeperWidget = /** @class */ (function (_super) {
    __extends(WhoIsRegisteredKeeperWidget, _super);
    function WhoIsRegisteredKeeperWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.vehicleIndex = (0, commonFunctions_1.getIndexSetting)("vehicleIndex", _this.getSetting("vehicleIndex", undefined), _this.props.question.type);
        _this.handleOnChangeEvent = function (event) {
            if (event.target.value === "false") {
                _this.props.onStateChange(_this.props.question.interactionField, "");
                _this.setState({
                    registeredKeeperId: "",
                    showConfirmation: true
                });
            }
            else {
                _this.props.onStateChange(_this.props.question.interactionField, event.target.value);
                _this.setState({
                    registeredKeeperId: event.target.value,
                    showConfirmation: false
                });
            }
            _super.prototype.validateInternal.call(_this, event.target.value);
            _this.changelogRecorder.recordQuestion("change", _this.props);
        };
        _this.state = {
            registeredKeeperId: _this.props.interaction.vehicles[_this.vehicleIndex].registeredKeeperId,
            showConfirmation: false,
            redirect: false,
            carToReplacePolicy: {},
            carToReplacePolicyIsLoaded: null
        };
        _this.isReplaceCarJourney = _this.getSetting("isReplaceCarJourney", false);
        return _this;
    }
    WhoIsRegisteredKeeperWidget.prototype.componentDidMount = function () {
        var _this = this;
        if (this.isReplaceCarJourney) {
            this.setState({ carToReplacePolicyIsLoaded: false });
            this.customerPortalService.getPolicy(this.props.engine.getInteraction().agreementNumber).subscribe(function (policy) {
                _this.setState({
                    carToReplacePolicy: policy,
                    carToReplacePolicyIsLoaded: true
                });
            });
        }
    };
    WhoIsRegisteredKeeperWidget.prototype.renderInputField = function () {
        var _a;
        var _this = this;
        var carToReplacePolicyIsLoaded = (_a = this.state, _a.carToReplacePolicyIsLoaded), carToReplacePolicy = _a.carToReplacePolicy;
        var canAddDriver = true;
        if (carToReplacePolicyIsLoaded && carToReplacePolicy !== null && carToReplacePolicy.interaction.additionalDrivers &&
            (this.props.interaction.additionalDrivers && this.props.interaction.additionalDrivers.length > 0) &&
            (carToReplacePolicy.interaction.additionalDrivers.length < this.props.interaction.additionalDrivers.length)) {
            canAddDriver = false;
        }
        return (React.createElement("div", { className: "background-color-white" },
            React.createElement("div", { className: "media-body" }, this.renderHeader()),
            React.createElement(DriverKeeperPopupWidget_1.default, { show: this.state.showConfirmation, hide: function () { return _this.setState({ showConfirmation: false }); }, confirm: function () { return _this.props.engine.navigate("vehicle".concat(_this.vehicleIndex, "AddDriverPage"), false); }, title: "Registered keeper for this car", vehicleRegistrationNumber: "".concat(this.props.interaction.vehicles[this.vehicleIndex].registrationNumber), additionalDriversCount: this.props.interaction.additionalDrivers ? this.props.interaction.additionalDrivers.length : 0, driverFunction: "registered keeper", canAddDriver: canAddDriver }),
            this.renderDrivers(),
            React.createElement(components_1.Overlay, { show: carToReplacePolicyIsLoaded === false })));
    };
    WhoIsRegisteredKeeperWidget.prototype.checkRegisteredKeeper = function (driverId) {
        var registeredKeeperId = this.props.interaction.vehicles[this.vehicleIndex].registeredKeeperId;
        if (!registeredKeeperId || registeredKeeperId === "") {
            return false;
        }
        return registeredKeeperId === driverId;
    };
    WhoIsRegisteredKeeperWidget.prototype.renderHeader = function () {
        var _this = this;
        var drivers = [];
        drivers.push(this.props.interaction.policyHolder);
        this.props.interaction.additionalDrivers && drivers.push.apply(drivers, this.props.interaction.additionalDrivers);
        var driver = drivers.filter(function (d) { return d.personId === _this.props.interaction.vehicles[_this.vehicleIndex].driverIds[0]; })[0];
        var firstName = driver.firstName;
        var lastName = driver.lastName;
        var vehicle = this.props.interaction.vehicles[this.vehicleIndex];
        if (drivers.length > 1) {
            return (React.createElement("label", { className: "no-outline" },
                "Who is the registered keeper for ",
                vehicle.make,
                ", ",
                vehicle.model,
                " (",
                vehicle.registrationNumber,
                ")?"));
        }
        else {
            return (React.createElement("label", { className: "no-outline" },
                "Is ",
                firstName,
                " ",
                lastName,
                " the registered keeper for this car?"));
        }
    };
    WhoIsRegisteredKeeperWidget.prototype.renderDrivers = function () {
        var _this = this;
        var allDrivers = [this.props.interaction.policyHolder].concat(this.props.interaction.additionalDrivers || []);
        var vehicle = this.props.interaction.vehicles[0];
        var vehicleInformation = "".concat(vehicle.make, " ").concat(vehicle.model, " ").concat(vehicle.registrationNumber);
        if (allDrivers.length > 1) {
            return (React.createElement("div", { className: "d-block input-group margin-top-14", role: "group", "aria-label": "Who is registered keeper for ".concat((0, commonFunctions_1.trimParenthesesFromString)(vehicleInformation), "?") },
                allDrivers.map(function (driver, index) {
                    return React.createElement("div", { key: driver.personId, className: "custom-control margin-bottom-20-padding-left-0 " },
                        React.createElement("input", { className: "custom-radiobutton", type: "radio", name: "isThisRegisteredKeeper", id: "additional-driver-id-" + index, value: driver.personId, onChange: _this.handleOnChangeEvent, checked: _this.checkRegisteredKeeper(driver.personId) }),
                        React.createElement("label", { id: 'driver-label', className: "checkbox-label label-bg-transparent", htmlFor: "additional-driver-id-" + index },
                            driver.firstName,
                            " ",
                            driver.lastName));
                }),
                React.createElement("div", { className: "custom-control margin-bottom-20-padding-left-0 " },
                    React.createElement("input", { className: "custom-radiobutton", type: "radio", name: "isThisRegisteredKeeper", id: "isThisRegisteredKeeperfalse", value: "false", checked: false, onChange: this.handleOnChangeEvent }),
                    React.createElement("label", { id: 'driver-label', className: "checkbox-label label-bg-transparent", htmlFor: "isThisRegisteredKeeperfalse" }, "Other"))));
        }
        else {
            return (React.createElement("div", { className: "input-group margin-top-14", role: "group", "aria-label": "Who is registered keeper for ".concat((0, commonFunctions_1.trimParenthesesFromString)(vehicleInformation), "?") },
                React.createElement("div", { className: "custom-control custom-radio" },
                    React.createElement("input", { className: "custom-control-input ".concat(this.getInputValidationClass()), type: "radio", name: "isThisRegisteredKeeper-true", id: "isThisRegisteredKeepertrue", value: this.props.interaction.vehicles[this.vehicleIndex].driverIds[0], checked: this.checkRegisteredKeeper(this.state.registeredKeeperId), onChange: this.handleOnChangeEvent }),
                    React.createElement("label", { className: "custom-control-label", htmlFor: "isThisRegisteredKeepertrue" }, "Yes")),
                React.createElement("div", { className: "custom-control custom-radio" },
                    React.createElement("input", { className: "custom-control-input ".concat(this.getInputValidationClass()), type: "radio", name: "isThisRegisteredKeeper-false", id: "isThisRegisteredKeeperfalse", value: "false", checked: false, onChange: this.handleOnChangeEvent }),
                    React.createElement("label", { className: "custom-control-label", htmlFor: "isThisRegisteredKeeperfalse" }, "No"))));
        }
    };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.CustomerPortalService),
        __metadata("design:type", Object)
    ], WhoIsRegisteredKeeperWidget.prototype, "customerPortalService", void 0);
    return WhoIsRegisteredKeeperWidget;
}(FalconQuestionWidgetBase_1.FalconQuestionWidgetBase));
//# sourceMappingURL=WhoIsRegisteredKeeperWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/subscription/motor/WhoIsRegisteredKeeperWidget.js
// module id = 2596
// module chunks = 0